import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Button,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { userInfo } from "../utils/auth";
import { SubjectCodes, SubjectSchedule } from "../utils";
import api, { baseURL } from "../services/api";
import { toast } from "react-toastify";
// import { html2pdf } from "html2pdf.js";
// import * as html2pdf from "html2pdf.js";
// import html2pdf from "html2pdf.js/dist/html2pdf.bundle";

const MultipleAdmiCards = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const stateChecking = location.state?.details;
  console.log(stateChecking, "stateChecking");

  const [stateDetails, setStateDetails] = useState({});
  const handleBack = () => {
    navigate(`/admit-card-list`);
  };
  const [updatedStateList, setUpdatedStateList] = useState([]);
  const [availablePkIds, setAvailablePkIds] = useState([]);
  useEffect(() => {
    if (stateChecking?.selectedStudents?.length) {
      let list = [];
      let pk_ids = [];
      stateChecking?.selectedStudents?.forEach((item) => {
        // if (item?.remark && item?.remark !== "NaN") {
        if (item?.status == 0) {
          console.log("remark & status", item?.status, item?.remark);
        } else {
          pk_ids.push(item?.pk_id);
          let cleanedStateDetails = Object.fromEntries(
            Object.entries({
              ...item,
              ...item?.student_compart_form_data?.other_data,
            }).map(([key, value]) => [key, value === "NaN" ? "" : value])
          );
          list.push(cleanedStateDetails);
        }
      });

      // cleanedStateDetails?.adh11 = cleanedStateDetails?.adh11=='00'? '': cleanedStateDetails?.adh11
      setUpdatedStateList([...list]);
      setAvailablePkIds([...pk_ids]);
    }
  }, [stateChecking]);
  console.log(updatedStateList, "updatedStateList");

  const printRef = useRef();

  const handlePrint = async () => {
    try {
      const response = await api.post("compartment/admit-card-download", {
        sch: userInfo()?.school_details?.schoolCode,
        pk_id: availablePkIds,
      });
      console.log(response, "response");
      if (response?.data?.success) {
        window.print();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ??
          "Error downloading in, please try again."
      );
    }
    // handleGeneratePDFAndPrint();
    // const originalContents = document.body.innerHTML;
    // const printContents = document.getElementById("print-section").innerHTML;
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents;
    // window.location.reload();
  };

  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    return () => document.removeEventListener("contextmenu", handleContextMenu);
  }, []);
  const [updatedSubjects, setUpdatedSubjects] = useState([]);
  const getSubjectDetails = (stateDetails) => {
    const data = {
      ...stateDetails,
    };
    const mapShift = (time) => {
      if (!time) return null;
      if (time.includes("FIRST SHIFT")) return "1st Shift";
      if (time.includes("SECOND SHIFT")) return "2nd Shift";
      return null;
    };
    const cleanTime = (time) => {
      if (!time) return null;
      return time.replace(/\s*\(.*?\)/, "").trim(); // remove shift part
    };
    const getWeekday = (dateStr) => {
      const [day, month, year] = dateStr.split("/").map(Number);
      const date = new Date(year, month - 1, day);
      return date
        .toLocaleDateString("en-US", { weekday: "long" })
        .toUpperCase();
    };
    const formatDate = (dateStr) => {
      return dateStr.replaceAll("/", ".");
    };

    const examArray = Array.from({ length: 7 }, (_, i) => {
      const index = i + 1;
      const date = data[`exdt${index}`];
      const subjectCode = data[`exnsub${index}`];
      const subjectShort = data[`exsub${index}`];
      const subjectFull = data[`exsub${index}nm`];
      const time = data[`extime${index}`];
      const shift = mapShift(time);

      if (!date || !subjectCode || !subjectShort || !subjectFull || !time)
        return null;

      return {
        date: formatDate(date),
        subjectCode,
        subjectShort,
        subjectFull,
        time: cleanTime(time),
        shift,
        weekday: getWeekday(date),
      };
    }).filter(Boolean); // remove null entries

    return [...examArray];
  };
  useEffect(() => {
    const data = {
      ...stateDetails,
    };
    const mapShift = (time) => {
      if (!time) return null;
      if (time.includes("FIRST SHIFT")) return "1st Shift";
      if (time.includes("SECOND SHIFT")) return "2nd Shift";
      return null;
    };
    const cleanTime = (time) => {
      if (!time) return null;
      return time.replace(/\s*\(.*?\)/, "").trim(); // remove shift part
    };
    const getWeekday = (dateStr) => {
      const [day, month, year] = dateStr.split("/").map(Number);
      const date = new Date(year, month - 1, day);
      return date
        .toLocaleDateString("en-US", { weekday: "long" })
        .toUpperCase();
    };
    const formatDate = (dateStr) => {
      return dateStr.replaceAll("/", ".");
    };

    const examArray = Array.from({ length: 7 }, (_, i) => {
      const index = i + 1;
      const date = data[`exdt${index}`];
      const subjectCode = data[`exnsub${index}`];
      const subjectShort = data[`exsub${index}`];
      const subjectFull = data[`exsub${index}nm`];
      const time = data[`extime${index}`];
      const shift = mapShift(time);

      if (!date || !subjectCode || !subjectShort || !subjectFull || !time)
        return null;

      return {
        date: formatDate(date),
        subjectCode,
        subjectShort,
        subjectFull,
        time: cleanTime(time),
        shift,
        weekday: getWeekday(date),
      };
    }).filter(Boolean); // remove null entries

    setUpdatedSubjects([...examArray]);
  }, [stateDetails]);

  console.log(updatedSubjects, "updatedSubjects");
  const formatAadhar = (aadhar) =>
    aadhar
      ?.replace(/\D/g, "")
      ?.replace(/(.{4})/g, "$1-")
      ?.replace(/-$/, "");
  return (
    <>
      <Box
        className="no-print"
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "20px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 4 }}
          onClick={handleBack}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 4, ml: 1 }}
          onClick={handlePrint}
        >
          {/* Download Admit {updatedStateList?.length===1 ? 'Card':"Cards"}  */}
          Print Admit Card
        </Button>
      </Box>

      <div
        ref={printRef}
        id="print-section"
        style={{
          userSelect: "none",
          WebkitUserSelect: "none",
          msUserSelect: "none",
        }}
      >
        {updatedStateList?.map((stateDetails) => (
          <Paper
            sx={{
              p: 2,
              //   maxWidth: 1100,
              width: "97%",
              mx: "auto",
              height: "1900px",
              // maxHeight: "1900px",
              //   border: "0.01px solid black",
              // marginTop: "200px",
            }}
            className="print-scale"
          >
            {/* Header */}
            <Grid
              container
              //   spacing={2}
              alignItems="center"
              border="3px solid black"
            >
              <Grid item xs={2}>
                <Avatar
                  src="/new-bihar-logo.jpg"
                  alt="Logo"
                  variant="square"
                  sx={{ width: 100, height: 100, ml: 1 }}
                />
              </Grid>
              <Grid
                item
                xs={10}
                marginLeft={"-100px"}
                textAlign="center"
                mt={1}
              >
                <Typography
                  fontWeight="bold"
                  //   variant="h4"
                  sx={{
                    fontSize: "29px",
                    fontWeight: "900",
                    lineHeight: "35px",
                  }}
                >
                  बिहार विद्यालय परीक्षा समिति
                </Typography>
                <Typography
                  fontWeight="bold"
                  // fontSize="16px"
                  //   variant="h4"
                  sx={{
                    borderBottom: "2px solid black", // change thickness/color as needed
                    display: "inline-block", // helps the border stick only to the text width
                    fontSize: "25px",
                    fontWeight: "900",
                    lineHeight: "35px",
                  }}
                >
                  प्रवेश पत्र (
                  <span style={{ fontWeight: 900 }}>ADMIT CARD</span>)
                </Typography>

                <Typography
                  fontWeight="bold"
                  mt={1}
                  variant="h4"
                  sx={{
                    fontSize: "29px",
                    fontWeight: "900",
                    lineHeight: "35px",
                  }}
                >
                  माध्यमिक
                  {/* {stateDetails?.o_reg && stateDetails?.o_reg?.split("-")[2] != "24"
                ? " विशेष "
                : " कम्पार्टमेंटल "} */}
                  {stateDetails?.exam_type === "COMPARTMENTAL"
                    ? " कम्पार्टमेंटल "
                    : " विशेष "}
                  परीक्षा, 2025
                </Typography>
              </Grid>
            </Grid>

            {/* Main details */}
            <Box
              className="section table-container"
              mt={0}
              border="3px solid black"
              borderTop={"0px"}
            >
              <Grid container spacing={0}>
                {/* Left info */}
                <Grid item xs={9}>
                  {[
                    [
                      "* BSEB UNIQUE ID:",
                      stateDetails?.uniqueid
                        ? stateDetails?.uniqueid?.toString()?.includes(".0")
                          ? stateDetails?.uniqueid?.split(".0")[0]
                          : stateDetails?.uniqueid
                        : "_",
                    ],
                    [
                      "विद्यालय का कोड एवं नाम:",
                      `${userInfo()?.school_details?.schoolCode}-
                                      ${userInfo()?.school_details?.name}`,
                    ],
                    ["परीक्षार्थी का नाम:", stateDetails?.cname],
                    ["माता का नाम:", stateDetails?.mname],
                    ["पिता का नाम:", stateDetails?.fname],
                    [
                      "परीक्षार्थी का आधार नं:",
                      stateDetails?.adh11
                        ? formatAadhar(stateDetails?.adh11)
                        : stateDetails?.student_compart_form_data?.other_data
                            ?.adh11
                        ? formatAadhar(
                            stateDetails?.student_compart_form_data?.other_data
                          )?.adh11
                        : "_",
                    ],
                    ["जन्म तिथि:", stateDetails?.dob],
                    ["परीक्षा की कोटि:", stateDetails?.rpname],
                    ["पंजीयन संख्या:", stateDetails?.o_reg],
                    ["रौल कोड:", userInfo()?.school_details?.schoolCode],
                    // [
                    //   "परीक्षा केन्द्र का कोड एवं नाम:",
                    //   "4102 - BANWARI SHANKER INTER COLLEGE, SIMRAHA, SAHARSA",
                    // ],
                  ].map(([label, value], i) => (
                    <Box
                      key={i}
                      sx={{
                        display: "flex",
                        borderTop: i === 0 ? "none" : "1px solid black",
                        // borderBottom: i === 9 ? "1px solid black" : "none",
                      }}
                    >
                      <Box
                        sx={{
                          width: "50%",
                          borderRight: "1px solid black",
                          p: 1,
                          fontWeight: i == 0 ? "bold" : "normal",
                          paddingBottom: 1.2,
                          paddingLeft: 0.7,
                          // height: "22px",
                          height: i === 0 || i === 6 ? "32px" : "22px",
                        }}
                      >
                        {label}
                      </Box>
                      <Box
                        sx={{
                          width: "50%",
                          p: 1,
                          fontWeight: "bold",
                          height: i === 0 || i === 6 ? "32px" : "22px",
                        }}
                      >
                        {/* {value} */}
                        {i === 0 || i === 6 ? (
                          <h2 style={{ margin: 0, height: "24px" }}>{value}</h2>
                        ) : i === 1 ? (
                          <span
                            style={{
                              display: "inline-block",
                              width: "100%",
                              fontSize: "14px", // base size
                              // whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              transform: `scale(${Math.min(
                                1,
                                180 / (value?.length || 1)
                              )})`,
                              marginTop: value?.length > 100 ? "-3px" : "0px",
                              // transformOrigin: "left center",
                            }}
                          >
                            {value}
                          </span>
                        ) : (
                          value
                        )}
                      </Box>
                    </Box>
                  ))}
                </Grid>

                {/* Right image and gender section */}
                <Grid item xs={3} sx={{ borderLeft: "1px solid black" }}>
                  <Box
                    sx={{
                      borderBottom: "1px solid black",
                      // height: "286px",
                      // maxHeight: "286px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 1,
                      flexDirection: "column",
                      // backgroundColor: "red",
                      height: "67.7%",
                    }}
                  >
                    <img
                      src={`${baseURL}${
                        stateDetails?.student_compart_form_data?.photograph_path?.startsWith(
                          "/"
                        )
                          ? stateDetails?.student_compart_form_data?.photograph_path?.slice(
                              1
                            )
                          : stateDetails?.student_compart_form_data
                              ?.photograph_path ||
                            (stateDetails?.photograph_path?.startsWith("/")
                              ? stateDetails?.photograph_path?.slice(1)
                              : stateDetails?.photograph_path) ||
                            (stateDetails?.photo?.startsWith("/")
                              ? stateDetails?.photo?.slice(1)
                              : stateDetails?.photo)
                      }`}
                      alt="Student"
                      style={{
                        width: "220px",
                        height: "220px",
                        objectFit: "cover", // ensure proper fill
                        display: "block",
                      }}
                    />

                    <img
                      src={`${baseURL}${
                        stateDetails?.student_compart_form_data
                          ?.signature_path ||
                        stateDetails?.signature_path ||
                        stateDetails?.sign
                      }`}
                      alt="Signature"
                      style={{
                        // width: "100%",
                        // height: "100%",
                        width: "220px",
                        maxHeight: "56px",
                        objectFit: "cover",
                        display: "block",
                        marginTop: "5px",
                      }}
                    />
                  </Box>
                  <Box sx={{ borderBottom: "1px solid black", p: 1.1 }}>
                    <Typography
                      sx={{
                        height: "22px",
                      }}
                    >
                      लिंग:
                      <b>
                        {stateDetails?.sex == "F"
                          ? " Female"
                          : stateDetails?.sex == "M"
                          ? " Male"
                          : " Other"}
                      </b>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      borderBottom: "1px solid black",
                      p: 1,
                      paddingBottom: 1.2,
                    }}
                  >
                    <Typography
                      sx={{
                        height: "22px",
                      }}
                    >
                      कोटि-(a) जाति: <b>{stateDetails?.caste} </b> (b) दिव्यांग:
                      <b>
                        {" "}
                        {stateDetails?.ph === "B"
                          ? "Yes"
                          : stateDetails?.VisuallyImpared
                          ? stateDetails?.VisuallyImpared
                          : stateDetails?.student_compart_form_data?.other_data
                              ?.VisuallyImpared
                          ? stateDetails?.student_compart_form_data?.other_data
                              ?.VisuallyImpared
                          : stateDetails?.ph === "B"
                          ? "Yes"
                          : "No"}
                      </b>
                    </Typography>
                  </Box>
                  <Box sx={{ p: 0, ml: 1 }}>
                    <Typography
                      sx={{
                        height: "22px",
                      }}
                    >
                      रौल नम्बर:{" "}
                      <h4
                        style={{
                          display: "inline",
                          margin: 0,
                          fontSize: "25px",
                          fontWeight: "900",
                          lineHeight: "35px",
                        }}
                      >
                        {stateDetails?.rollno}
                      </h4>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    key={7}
                    sx={{
                      display: "flex",
                      borderTop: "1px solid black",
                    }}
                  >
                    <Box
                      sx={{
                        width: "59%",
                        borderRight: "1px solid black",
                        p: 1,
                        fontWeight: "normal",
                      }}
                    >
                      परीक्षा केन्द्र का कोड एवं नाम:
                    </Box>
                    <Box sx={{ width: "100%", p: 1, fontWeight: "bold" }}>
                      <h3 style={{ display: "inline", margin: 0 }}>
                        {stateDetails?.cent}-{stateDetails?.centname}
                      </h3>
                    </Box>
                  </Box>
                </Grid>
                {/* <Grid item xs={12}>
                  <Box
                    key={7}
                    sx={{
                      display: "flex",
                      borderTop: "1px solid black",
                    }}
                  >
                    <Box
                      sx={{
                        width: "59%",
                        borderRight: "1px solid black",
                        p: 1,
                        fontWeight: "normal",
                      }}
                    >
                      remarks
                    </Box>
                    <Box sx={{ width: "100%", p: 1, fontWeight: "bold" }}>
                      <h3 style={{ display: "inline", margin: 0 }}>
                        {stateDetails?.remark ? stateDetails?.remark : "-"}
                      </h3>
                    </Box>
                  </Box>
                </Grid> */}
              </Grid>
            </Box>

            {/* Subject Table */}
            <Box
              mt={0}
              border="3px solid black"
              borderTop={"0px"}
              borderBottom={"0px"}
            >
              <Typography p={1}>
                परीक्षा के विषय (निर्धारित परीक्षा कार्यक्रमानुसार):
              </Typography>
              <TableContainer
                component={Box}
                sx={{
                  borderTop: "1px solid black",

                  minHeight: "310px",
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#1C3144" }}>
                      <TableCell
                        sx={{
                          border: "1px solid black",
                          fontWeight: "bold",
                          color: "white",
                          textAlign: "center",
                          fontSize: "18px",
                        }}
                      >
                        विषय कोड
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid black",
                          fontWeight: "bold",
                          color: "white",
                          textAlign: "center",
                          fontSize: "18px",
                        }}
                      >
                        विषय का नाम
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid black",
                          fontWeight: "bold",
                          color: "white",
                          textAlign: "center",
                          fontSize: "18px",
                        }}
                      >
                        परीक्षा की तिथि
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid black",
                          fontWeight: "bold",
                          color: "white",
                          textAlign: "center",
                          fontSize: "18px",
                        }}
                      >
                        पाली
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid black",
                          fontWeight: "bold",
                          color: "white",
                          textAlign: "center",
                          fontSize: "18px",
                        }}
                      >
                        परीक्षा का समय
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getSubjectDetails(stateDetails)?.map((subject, index) => (
                      <TableRow key={index}>
                        <TableCell
                          sx={{
                            border: "1px solid black",
                            borderLeft: "0px",
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize: "20px",
                          }}
                        >
                          {subject?.subjectCode?.toString()?.includes(".0")
                            ? subject?.subjectCode?.toString()?.split(".0")[0]
                            : subject?.subjectCode}
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid black",
                            fontWeight: "bold",
                            // textAlign: "left",
                            fontSize: "20px",
                            // marginLeft: "20px",
                          }}
                        >
                          <Box sx={{ pl: 4, textAlign: "left" }}>
                            {SubjectCodes?.[subject?.subjectShort]}
                          </Box>
                          {/* {subject?.subjectFull} */}
                          {/* {SubjectCodes?.[subject?.subjectShort]} */}
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid black",
                            fontWeight: "bold",
                            // textAlign: "left",
                            fontSize: "20px",
                          }}
                        >
                          <Box sx={{ pl: 4, textAlign: "left" }}>
                            {subject?.date} ({subject?.weekday})
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid black",
                            fontWeight: "bold",
                            // textAlign: "left",
                            fontSize: "20px",
                          }}
                        >
                          <Box sx={{ pl: 4, textAlign: "left" }}>
                            {subject?.shift}
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "1px solid black",
                            fontWeight: "bold",
                            // textAlign: "left",
                            fontSize: "20px",
                            // borderLeft: "0px",
                            borderRight: "0px",
                          }}
                        >
                          <Box sx={{ pl: 4, textAlign: "left" }}>
                            {subject?.time}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* Footer */}
            <Box
              mt={0}
              display="flex"
              justifyContent="space-between"
              border="3px solid black"
              borderTop={"0px"}
            >
              <Typography fontSize="14px" mt={12} ml={2}>
                विद्यालय प्रधान का हस्ताक्षर एवं विद्यालय की मुहर
              </Typography>
              <Box textAlign={"center"} m={1} mb={0}>
                {/* <Typography fontWeight="bold">Sanjay Kumar</Typography> */}
                <Avatar
                  src={"/singnature.png"}
                  alt="Student"
                  variant="square"
                  objectFit="contain"
                  sx={{ width: 300, height: 70 }}
                />
                <Typography mt={2}>परीक्षा नियंत्रक</Typography>
              </Box>
            </Box>
            <Box className="instructions-box " mt={0} p={2} pt={0.5}>
              <Box textAlign="center">
                <Typography
                  fontWeight="bold"
                  sx={{
                    borderBottom: "2px solid black",
                    display: "inline-block",
                  }}
                  mb={0.5}
                >
                  परीक्षार्थी के लिए आवश्यक निर्देश :
                </Typography>
              </Box>
              {[
                "* BSEB UNIQUE ID सत्र 2022-23 से पंजीकृत हुए नियमित (Regular) तथा स्वतंत्र (Private) परीक्षार्थियों को ही जारी किया गया है। सत्र 2022-23 के पूर्व सत्र के किसी परीक्षार्थी को BSEB UNIQUE ID जारी नहीं किया गया है।",
                "जाँच परीक्षा में उत्प्रेषित (Sent-up) छात्र/छात्रा के लिए ही यह मूल प्रवेश पत्र मान्य होगा। जाँच परीक्षा में अनुत्तीर्ण अथवा अनुपस्थित छात्र/छात्रा के लिए यह मूल प्रवेश पत्र मान्य नहीं है। प्रवेश पत्र पर विद्यालय प्रधान का हस्ताक्षर एवं विद्यालय की मुहर नहीं रहने पर प्रवेश पत्र की मान्यता नहीं दी जायेगी। .",
                "परीक्षार्थी को परीक्षा केन्द्र पर इस प्रवेश पत्र के साथ एक फोटोयुक्त पहचान पत्र लाना अनिवार्य है।",
                "प्रथम पाली के परीक्षार्थी को परीक्षा प्रारम्भ होने के समय पूर्वाहन 09:30 बजे से 30 मिनट पूर्व अर्थात् पूर्वाह्न 09:00 बजे तक तथा द्वितीय पाली के परीक्षार्थी को द्वितीय पाली के परीक्षा प्रारम्भ होने के समय अपराह्न 02:00 बजे से 30 मिनट पूर्व अर्थात् अपराह्न 01:30 बजे तक ही परीक्षा भवन में प्रवेश की अनुमति दी जाएगी। विलम्ब से आने वाले परीक्षार्थी को परीक्षा भवन में प्रवेश की अनुमति नहीं मिलेगी।",
                "परीक्षा भवन में जूता-मोजा पहन कर आना सर्वथा वर्जित है अन्यथा परीक्षा भवन में प्रवेश की अनुमति नहीं मिलेगी। परीक्षा केन्द्र में कैलकुलेटर, मोबाईल फोन, ब्लूटूथ, ईयरफोन या अन्य इलेक्ट्रॉनिक गैजेट्स आदि लाना/प्रयोग करना वर्जित है। परीक्षार्थी परीक्षा भवन में प्रवेश पत्र एवं पेन के अलावा कुछ भी नहीं ले जायेंगे और निर्दिष्ट स्थान/सीट पर ही बैठेंगे।",
                "परीक्षार्थी को प्रत्येक विषय की परीक्षा के लिए एक ओ०एम०आर० उत्तर पत्रक एवं एक उत्तरपुस्तिका मिलेगी, जिस पर परीक्षार्थी की विवरणी अंकित रहेगा। परीक्षार्थी ओ०एम०आर० उत्तर पत्रक एवं उत्तरपुस्तिका प्राप्त करने के उपरांत जाँच कर आश्वस्त हो लेंगे कि यह ओ०एम०आर० उत्तर पत्रक एवं उत्तरपुस्तिका उन्हीं की है। अतिरिक्त ओ०एम०आर० उत्तर पत्रक एवं उत्तरपुस्तिका नहीं दी जाएगी।",
                `उत्तरपुस्तिका प्राप्त होने पर परीक्षार्थी उनके आवरण पृष्ठ पर अंकित "परीक्षार्थियों के लिए निर्देश" अवश्य पढ़ेंगे एवं उसका अनुपालन करेंगे।`,
                "परीक्षार्थी द्वारा उत्तरपुस्तिका के कवर पृष्ठ के बार्यों भाग में केवल विषय का नाम एवं उत्तर देने का माध्यम अंकित किया जाएगा और जिस सेट कोड का प्रश्न पत्र आपको मिला है, उस प्रश्न पत्र सेट कोड को बॉक्स में अंकित करते हुए प्रश्न पत्र सेट कोड वाले गोलक को काले/नीले बॉल पेन से भरा जाएगा (प्रगाढ़ किया जाएगा)। उ०पु० के दाहिना भाग में भी प्रश्न पत्र सेट कोड को बॉक्स में अंकित करते हुए प्रश्न पत्र सेट कोड वाले गोलक को भरा जाएगा (प्रगाढ़ किया जाएगा) एवं निर्दिष्ट स्थान में प्रश्न पत्र क्रमांक अंकित करते हुए अपना पूरा नाम एवं विषय का नाम अंकित कर परीक्षार्थी द्वारा अपना पूर्ण हस्ताक्षर किया जाएगा। ओ०एम०आर० उत्तर पत्रक में भी परीक्षार्थी द्वारा निर्दिष्ट स्थान में प्रश्न पत्र क्रमांक, परीक्षा केन्द्र का नाम, अपना पूर्ण हस्ताक्षर तथा प्रश्न पत्र का सेट कोड को निर्दिष्ट बॉक्स में अंकित करते हुए प्रश्न पत्र सेट कोड वाले गोलक को काले/नीले बॉल पेन से भरा जाएगा (प्रगाढ़ किया जाएगा)। . ",
                "उत्तरपुस्तिका के पृष्ठों को मोड़ेंगे-फाड़ेंगे नहीं तथा बीच-बीच में व्यर्थ ही खाली नहीं छोड़ेगें।",
                "प्रश्न-पत्र में दी हुई संख्या के अनुसार अपने उत्तरों की संख्या लिखेंगे तथा प्रश्नोत्तर के समाप्त होने पर अंतिम में एक नीचे क्षेतिज रेखा खींच देंगे।",
                "यदि उ०पु० में रफ कार्य करने की आवश्यकता हो, तो परीक्षार्थी उत्तरपुस्तिका के अन्तिम पृष्ठ पर रफ कार्य कर सकते हैं परन्तु परीक्षोपरान्त परीक्षार्थी द्वारा उस रफ कार्य को काट/क्रॉस (X) कर देना अनिवार्य होगा।",
                "उपस्थिति पत्रक (A एवं B) के निर्दिष्ट स्थान में परीक्षार्थी द्वारा प्रत्येक विषय की परीक्षा में प्रश्न पत्र क्रमांक, उत्तरपुस्तिका एवं ओ०एम०आर० उत्तर पत्रक की क्रम संख्या तथा निर्धारित बॉक्स में प्रश्न पत्र सेट कोड अंकित किया जाएगा एवं प्रश्न पत्र सेट कोड वाले गोलक को काले/नीले बॉल पेन से भरते हुए (प्रगाढ़ करते हुए) अपना पूर्ण हस्ताक्षर किया जाएगा।",
                "परीक्षा कक्ष में एक-दूसरे से मदद लेने या देने, बातचीत करने अथवा किसी प्रकार का कदाचार अपनाने के अपराध में पकड़े गये परीक्षार्थी को परीक्षा से निष्कासित कर दिया जाएगा। उत्तरपुस्तिका एवं ओ०एम० आर० उत्तर पत्रकों पर व्हाईटनर, इरेजर, नाखून, ब्लेड आदि का इस्तेमाल करना सर्वथा वर्जित है। ऐसा पाये जाने पर कदाचार का मामला मानते हुए परीक्षाफल अमान्य (Invalid) कर दिया जाएगा।",
                "परीक्षा प्रारम्भ होने से एक घंटा के अंदर किसी भी परीक्षार्थी को परीक्षा केन्द्र से बाहर जाने की अनुमति नहीं होगी। वीक्षक को समर्पित ओ०एम०आर० उत्तर पत्रक एवं उत्तरपुस्तिका परीक्षार्थी को पुनः नहीं लौटायी जाएगी।",
                "यदि किसी विद्यालय प्रधान द्वारा अपने विद्यालय के किसी भी परीक्षार्थी के निर्गत हुए प्रवेश पत्र में उसके किसी भी विवरण में अपने स्तर से सुधार/परिवर्तन कर दिया जाता है, तो उस सुधार को बिल्कुल मान्यता नहीं देते हुए केन्द्राधीक्षक द्वारा उस परीक्षार्थी को मात्र उसके प्रवेश पत्र, रौल शीट तथा उपस्थिति पत्रक में अंकित विवरणों के आधार पर ही परीक्षा में सम्मिलित कराया जाएगा। साथ ही प्रवेश पत्र के मुद्रित विवरण में परिवर्तन करने वाले विद्यालय प्रधान के विरूद्ध नियमानुसार प्रशासनिक एवं कानूनी कार्रवाई की जाएगी।",
              ].map((line, index) => (
                <Box
                  key={index}
                  display="flex"
                  alignItems="flex-start"
                  mb={0.5}
                >
                  <Typography
                    fontSize="14px"
                    fontWeight="bold"
                    sx={{ minWidth: "24px", textAlign: "right", pr: 1 }}
                  >
                    {index + 1}.
                  </Typography>
                  {index === 6 ? (
                    <Typography key={7} fontSize="15.5px" mb={0.5}>
                      {
                        "उत्तरपुस्तिका प्राप्त होने पर परीक्षार्थी उनके आवरण पृष्ठ पर अंकित "
                      }
                      <b>“परीक्षार्थियों के लिए निर्देश”</b>
                      {" अवश्य पढ़ेंगे एवं उसका अनुपालन करेंगे।"}
                    </Typography>
                  ) : (
                    <Typography
                      fontSize="15.5px"
                      sx={{
                        fontWeight: index === 1 ? "bold" : "normal",
                        fontSize: "15.5px",
                      }}
                    >
                      {line.replace(/^\d+\.\s*/, "")}
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
          </Paper>
        ))}
      </div>
    </>
  );
};

export default MultipleAdmiCards;
